import Label from '@pixum/label';
import styles from './ArticleInactiveLabel.module.css';
import Icon from '@pixum/icon';
import { TextVariant } from '@pixum/text';
import clsx from 'clsx';

interface ArticleInactiveLabelProps {
  className?: string;
  text: string;
}

export function ArticleInactiveLabel({ text, className }: ArticleInactiveLabelProps) {
  return (
    <Label
      className={clsx(className, styles['label'])}
      icon={<Icon className={styles.icon} name="warningsignal" size="small" ariaHidden />}
      text={text}
      variant={TextVariant.CAPTION_XS}
    />
  );
}
